// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"PaymentPage_submitButton__3QlYf","info":"PaymentPage_info__EuTXm"};